import { render, staticRenderFns } from "./textinputelement.vue?vue&type=template&id=4a911770&scoped=true"
import script from "./textinputelement.vue?vue&type=script&lang=js"
export * from "./textinputelement.vue?vue&type=script&lang=js"
import style0 from "./textinputelement.vue?vue&type=style&index=0&id=4a911770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a911770",
  null
  
)

export default component.exports